import React, { useContext, useRef } from 'react';
import './style.scss';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import { CardsReward_context } from '../../context';

const Item = (props) => {
  const { item, index } = props;

  const {
    gridExpander,
    setSelectedItemState,
    setSelectedItemIndex,
    selectedItemIndex,
    isCarousel,
  } = useContext(CardsReward_context);
  const itemRef = useRef();
  const itemClosedRef = useRef();
  let timeoutOpen = 0;
  const handleOpen = () => {
    setSelectedItemState(itemRef);
    if (index !== -1 && index !== selectedItemIndex) {
      setSelectedItemIndex(index);
      timeoutOpen = setTimeout(() => {
        let height = itemRef.current.clientHeight - itemClosedRef.current.clientHeight;
        gridExpander.current.style.height = height + 'px';
      }, 1);
    } else {
      gridExpander.current.style.height = '0px';
      setSelectedItemIndex(-1);
      clearTimeout(timeoutOpen);
    }
  };

  const ico_diagram_white = '/-/media/Project/FAB2/shared/images/ico_diagram-white.svg';
  const ico_angleDown_white = '/-/media/Project/FAB2/shared/images/ico_angleDown-white.svg';
  const bg_cardGradiant_big = '/-/media/Project/FAB2/shared/images/bg_cardGradiant-big.svg';
  const bg_cardGradiant_sm = '/-/media/Project/FAB2/shared/images/bg_cardGradiant-small.svg';
  const line_cardGradient = '/-/media/Project/FAB2/shared/images/line_cardGradient.svg';
  const _link = item?.url;
  const heading = item?.title;
  const image = item?.image;
  const bannerImage = item?.bannerImage;

  const { description, sections } = item?.reward;

  const shouldRenderImage = !!image?.value?.src && image?.value?.src && image?.value?.src !== '';
  const shouldRenderBannerImage =
    !!bannerImage?.value?.src && bannerImage?.value?.src && bannerImage?.value?.src !== '';
  const shouldRenderTitle = !!heading?.value && heading !== '';
  const shouldRenderDescription = !!description && description?.value !== '';
  const shouldRenderSections = !!sections && sections?.length > 0 && Array.isArray(sections);
  const displayShowMoreIcon = item?.reward?.displayShowMoreIcon?.value && !isCarousel;
  const shouldRenderLink = _link !== '';
  return (
    <div
      className={clsx('crgv__innerItem', selectedItemIndex === index ? 'open' : '')}
      ref={itemClosedRef}
    >
      <div className="crgv__auto" ref={itemRef}>
        <div className="crgv__innerSpace">
          <div className="crgv__top">
            <div className="crgv__image">
              {/*START layer that can contain icon or card */}
              <div className="crgv__cardOrImage flex-it flex-align-item-center">
                <div className="crgv__cardOrImage__layers">
                  <img border="0" src={bg_cardGradiant_big} />
                </div>
                {shouldRenderBannerImage && (
                  <div className="crgv__cardOrImage__content">
                    <Image className="crgv__cardOrImage__icon" field={bannerImage} />
                  </div>
                )}

                <div className="crgv__card">
                  {!shouldRenderImage && (
                    <>
                      <div className="crgv__cardOrImage__layers">
                        <img border="0" src={bg_cardGradiant_sm} />
                      </div>
                      <div className="crgv__defaultIcon flex-it flex-align-item-center flex-justify-center">
                        <img border="0" src={ico_diagram_white} />
                      </div>
                    </>
                  )}

                  <div className="crgv__card__content">
                    {shouldRenderImage && <Image className="crgv__card__icon" field={image} />}
                  </div>
                </div>
              </div>
            </div>

            {/* END layer */}
          </div>
          <div className="crgv__middle_bottom">
            <div className="crgv__middle">
              {shouldRenderLink && (
                <a href={_link} target="_blank" rel="noreferrer noopener">
                  {shouldRenderTitle && <RichText className={'crgv__title'} field={heading} />}
                </a>
              )}
              {!shouldRenderLink && shouldRenderTitle && (
                <RichText className={'crgv__title'} field={heading} />
              )}
              {shouldRenderDescription && (
                <RichText className={'crgv__description'} field={description} />
              )}
              {shouldRenderSections && (
                <div className="crgv__table">
                  <TableRowComponent sections={sections} />
                </div>
              )}
              {displayShowMoreIcon && (
                <div
                  className="crgv__bottom card-reward-bottom-toggle"
                  onClick={(e) => handleOpen(e)}
                >
                  <div className="crgv__bottom__line">
                    <img border="0" src={line_cardGradient} />
                  </div>
                  <div className="crgv__bottom__button flex-it flex-wrap flex-align-item-center flex-justify-center">
                    <img border="0" src={ico_angleDown_white} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const TableRowComponent = (props) => {
  const { sections } = props;
  return sections?.map((item, index) => {
    return (
      <div className="crgv__row" key={index}>
        <RichText className="crgv__row__header" field={item?.text} />
        {item?.items?.map((subItem, index2) => {
          const fullRow =
            subItem?.fields?.number?.value === '' && subItem?.fields?.adornmentText === '';
          return (
            <div className="crgv__parts flex-it flex-wrap flex-align-item-start" key={index2}>
              <RichText
                className={clsx('crgv__leftPart', fullRow ? 'full-row' : '')}
                field={subItem?.fields?.description}
              />
              <div className="crgv__rightPart flex-it flex-wrap flex-align-item-start">
                <div className="crgv__subLeft">{subItem?.fields?.number?.value}</div>
                <RichText className="crgv__subRight" field={subItem?.fields?.adornmentText} />
              </div>
            </div>
          );
        })}
      </div>
    );
  });
};
export default Item;
